var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.expired.icon)?_c('div',{staticClass:"img_icon",attrs:{"title":_vm.file.computedName}},[_c('a-icon',{style:(_vm.expired.style),attrs:{"theme":"filled","type":_vm.expired.icon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }